import { AnyAction } from 'redux';
import {
  REGISTER_ERROR,
  REGISTER_SET_INFO,
  REGISTER_SET_IS_LOADING,
  REGISTER_SET_REGISTER_MODE
} from '../constants';
import RegisterMode from '../Types/RegisterMode';

export interface RegisterState {
  payload: any;
  isLoading: boolean;
  error?: string;
  registerMode: RegisterMode;
}

const DEFAULT_STATE: RegisterState = {
  payload: {
    registerInfo: {},
  },
  isLoading: false,
  error: undefined,
  registerMode: RegisterMode.Register
};

export const register = (state = DEFAULT_STATE, action: AnyAction): RegisterState => {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SET_INFO:
        return {
            ...state,
            payload: {
                ...state.payload,
                [payload.key]: {
                    ...state.payload[payload.key],
                    ...payload.data,
                },
            },
        };
    case REGISTER_ERROR:
    case REGISTER_SET_IS_LOADING:
    case REGISTER_SET_REGISTER_MODE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
